import { reactAppVersion } from "src/features/auth/axiosConfig";

type RouteHandler = (employee?: string) => string;

const routeConfig: Record<string, RouteHandler> = {
  Laundry: (employee) => (employee ? "/v1/employee/home" : "/v1/home"),
  Restaurant: () => "/v1/Reshome",
  Carwash: () => "/v1/new-order",
  "Car wash": () => "/v1/new-order",
  "Vechicle retailer": () => "/v1/vechicle-home",
  Saloon: () => "/v1/saloon-Home",
  Grocery: () => `/grocery/${reactAppVersion}/home`,
};

export const useBusinessRoutes = () => {
  const getRouteForBusiness = (businessType: string, employee?: string) => {
    const handler = routeConfig[businessType];
    return handler ? handler(employee) : "/";
  };

  return { getRouteForBusiness };
};
